<form [formGroup]="expoNoteForm" action="submit" class="notes-container" (submit)="onSubmit()">
    <div ngbAccordion class="notes-accordion" (shown)="onPanelShow($event)" >
        <div ngbAccordionItem [title]="'expo.checkout.notes.title' | transloco">
            <ng-template ngbPanelContent>
                <textarea rows="1" class="notes-textarea form-input" type="text"
                    [placeholder]="'expo.checkout.notes.placeholder' | transloco"
                    formControlName="notes"></textarea>
            </ng-template>
        </div>
    </div>
</form>